import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=a84308ae"
import script from "./Slider.vue?vue&type=script&setup=true&lang=js"
export * from "./Slider.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a84308ae')) {
      api.createRecord('a84308ae', component.options)
    } else {
      api.reload('a84308ae', component.options)
    }
    module.hot.accept("./Slider.vue?vue&type=template&id=a84308ae", function () {
      api.rerender('a84308ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/forms/Slider.vue"
export default component.exports